import React from 'react';
import PropTypes from 'prop-types';
// import MapComponent from 'react-cartographer/lib/components/Map';
import MapComponent from './react-cartographer/lib/components/Map';
import {
    MTG_MAP_BING_KEY,
    MTG_MAP_ZOOM,
    MTG_MAP_LAT_DEFAULT,
    MTG_MAP_LONG_DEFAULT,
    MTG_MAP_ADDRESS_DEFAULT,
} from '../../../../helpers/constants';

class BingMap extends React.Component {

    constructor() {
        super();

        this.state = {
            shouldDisplayPlaceholder: false
        };
    }

    render() {
        const shouldDisplayPlaceholder = this.state.shouldDisplayPlaceholder
        const { latitude, longitude, mapId, width, height } = this.props;
        let { address } = this.props;

        let fltLatitude = parseFloat(latitude);
        let fltLongitude = parseFloat(longitude);
        const intWidth = parseInt(width, 10);
        const intHeight = parseInt(height, 10);

        if (address.length === 0) {
            address = MTG_MAP_ADDRESS_DEFAULT;
            fltLatitude = parseFloat(MTG_MAP_LAT_DEFAULT);
            fltLongitude = parseFloat(MTG_MAP_LONG_DEFAULT);
        }

        // console.log("BingMap", fltLongitude, fltLatitude, address.length);

        return shouldDisplayPlaceholder ? (
            <div className="no-location text-muted">
                <i className="fa fa-map-marker fa-5x d-block"></i>
                <br />Offline
</div>
        ) : (
                <MapComponent
                    provider="bing"
                    providerKey={MTG_MAP_BING_KEY}
                    mapId={mapId.toString()}
                    addressLine1={address}
                    latitude={fltLatitude}
                    longitude={fltLongitude}
                    zoom={MTG_MAP_ZOOM}
                    height={intHeight}
                    width={intWidth}
                    callback={() => {
                        this.setState({
                            shouldDisplayPlaceholder: true
                        })
                    }
                    }
                />
            )
    }
}

BingMap.propTypes = {
    latitude: PropTypes.string.isRequired,
    longitude: PropTypes.string.isRequired,
    address: PropTypes.string,
    mapId: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
};

BingMap.defaultProps = {
    address: MTG_MAP_ADDRESS_DEFAULT,
    longitude: MTG_MAP_LONG_DEFAULT,
    latitude: MTG_MAP_LAT_DEFAULT,
};

export default BingMap;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/BingMap.js